import { Container, Stack, Theme, Toolbar } from '@mui/material';
import { Outlet } from '@tanstack/react-router';
import { FC } from 'react';

import { createUseStyles } from 'react-jss';
import AppHeader from './components/app-header';
import ModalRoot from './contexts/modal/modal-root';
import useApp from './hooks/use-app.hook';
import { useDocumentTitle } from 'usehooks-ts';
import useFavicon from './hooks/use-favicon.hook';

const useStyles = createUseStyles((theme: Theme) => ({
  main: {
    flexGrow: 1,
    overflow: 'auto',
  },
  content: {
    margin: '15px auto',
    flexGrow: 1,
  },
  '@global': {
    'html, body, #root': {
      height: '100%',
      width: '100%',
      margin: 0,
      padding: 0,
      overflow: 'hidden',
    },
    input: {
      '&:-webkit-autofill': {
        background: 'none',
        backgroundColor: 'transparent !important',
        backgroundClip: 'text',
      },
    },
    a: {
      color: theme.palette.link.main,
      textDecoration: 'none',
      '&:hover': {
        color: theme.palette.link.hover,
      },
      '&.flat': {
        color: theme.palette.common.black,
      },
    },
  },
}));

const App: FC = () => {
  const styles = useStyles();
  const { signedIn, pageTitle, branding } = useApp();
  const { plain } = pageTitle;
  const hasPageTitlePlain = !!plain;

  const documentTitle = branding?.name;
  const favicon = branding?.favicon || '/favicon-blank.png';

  useDocumentTitle(`${documentTitle}${hasPageTitlePlain ? ' |' : ''} ${plain}`);

  useFavicon(favicon);

  return (
    <>
      <Stack height="100%" width="100%">
        <AppHeader />
        <Stack
          component="main"
          className={styles.main}
          alignItems={signedIn ? 'flex-start' : 'center'}
        >
          <Toolbar />
          <Container className={styles.content}>
            <Outlet />
          </Container>
        </Stack>
      </Stack>
      <ModalRoot />
    </>
  );
};

export default App;
